import { Heading, Logo, Skeleton, Stack, Text } from "@nudgebox/ui";
import "@nudgebox/ui/tokens.stylex";
import { color, media, space } from "@nudgebox/ui/tokens.stylex";
import * as stylex from "@stylexjs/stylex";
import type { ReactNode } from "react";
import { AuthPreview } from "./AuthPreview.tsx";

/** Form on the left, a live miniature of the dashboard on the right (hidden on phones). */
function AuthFrame({
  busy = false,
  children
}: {
  busy?: boolean;
  children: ReactNode;
}) {
  return <div aria-busy={busy || undefined} className="xrvj5dj xcjjqqt xpo9xo4 xg6iff7 x1paulmi">
      <main className="x78zum5 xdt5ytf x1f3vwq8 x1ssaexl x1lavhwh">
        <div className="xs6izal xpitndw">
          <Logo />
        </div>
        <div className="x78zum5 xdt5ytf x9p7km9 xh8yej3 x1dt7z5j xvueqy4 x14lj2rd x1gtf3ba">{children}</div>
      </main>
      <aside className="x1lliihq x1hpag8f x7wzq59 x13vifvy x1dr59a3 xb3r6kr xvccuex xe0pwq x19ypqd9 x1u6ik13">
        <AuthPreview />
      </aside>
    </div>;
}
export function AuthLayout({
  title,
  subtitle,
  children,
  footer
}: {
  title: string;
  subtitle: ReactNode;
  children: ReactNode;
  footer: ReactNode;
}) {
  return <AuthFrame>
      <Stack gap="xs">
        <Heading level={1}>{title}</Heading>
        <Text tone="secondary">{subtitle}</Text>
      </Stack>
      {children}
      <Text size="sm" tone="tertiary">
        {footer}
      </Text>
    </AuthFrame>;
}

/** The auth page while it loads: same frame, a heading and a form's worth of fields. */
export function AuthLayoutPending() {
  return <AuthFrame busy>
      <Stack gap="sm">
        <Skeleton width={180} height={22} />
        <Skeleton width="80%" />
      </Stack>
      <Stack gap="lg">
        {[72, 88].map(width => <Stack key={width} gap="sm">
            <Skeleton width={width} height={12} />
            <Skeleton height={34} radius="md" />
          </Stack>)}
        <Skeleton height={34} radius="md" />
      </Stack>
      <Skeleton width={200} height={13} />
    </AuthFrame>;
}

// Same split as the onboarding page.